import $ from 'jquery';

initVideo();

function initVideo() {
    const $elements = $('.video');

    if ($elements.length < 1) {
        return;
    }

    const SELECTOR_VIDEO_PLAY = '[data-video-play]',
          SELECTOR_VIDEO_EMBED = '[data-video-item]',
          ATTRIBUTE_VIDEO_YOUTUBE = 'video-youtube',
          SELECTOR_FALLBACK_PICTURE = '.video__fallback',
          SELECTOR_VIDEO_BLOCKER = '.js-media-blocker';

    $elements.each((index, element) => {
        const $playButton = $(element).find(SELECTOR_VIDEO_PLAY),
              $videoEmbed = $playButton.prevAll(SELECTOR_VIDEO_EMBED),
              videoUrl = $playButton.data(ATTRIBUTE_VIDEO_YOUTUBE),
              fallbackImg = $(element).find(SELECTOR_FALLBACK_PICTURE),
              $mediaBlocker = $(element).find(SELECTOR_VIDEO_BLOCKER),
              $mediaBlockerButton = $mediaBlocker.find('button');

        $playButton.on('click', (event) => {
            let youtubeConsent;

            try {
                let serviceInfo = UC_UI.getServicesBaseInfo();
                youtubeConsent = serviceInfo.find(e => e.name === 'YouTube Video').consent.status
            } catch (error) {
                youtubeConsent = false;
            }

            if (youtubeConsent) {
                // Inject
                $videoEmbed.attr({
                    'src': videoUrl,
                    'hidden': null
                })

                hidePreview();

                $videoEmbed.on('load', () => {
                    $videoEmbed[0].focus();
                });
            } else {
                hidePreview();
                $mediaBlocker.addClass('d-flex').removeClass('d-none');
            }
        });

        $mediaBlockerButton.on('click', () => {
            $playButton.removeClass('d-none');
            fallbackImg.removeClass('d-none');
            $mediaBlocker.addClass('d-none').removeClass('d-flex');
            UC_UI.showSecondLayer();
        })

        function hidePreview() {
            $playButton.addClass('d-none');
            fallbackImg.addClass('d-none');
        }
    })
}
